// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"a9a4edd7","108":"5dea3bed","162":"f201ea90","199":"d5ae8764","370":"c38a6873","596":"8c9f51c2","639":"3278b6ab","697":"1de2a3c6"}[chunkId] + ".chunk.js";
};